import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BaseCreate from './Base/Create';
import BaseList from './Base/List';
import BaseEdit from './Base/Edit';
import List from './Inventory/List';
import Create from './Inventory/Create';
import './index.css';
import ErrorPage from '../Shared/ErrorPage';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import ProtectedRoute from '../Routes/ProtectedRoute.jsx';

const Inventory = () => {
  const actions = ConstantActions();
  return (
    <div className="inventory">
      <Routes>
        {/* Base Inventory */}
        <Route path="*" element={<ErrorPage />} />
        <Route
          exact
          path={`/base/create`}
          element={
            <ProtectedRoute
              element={<BaseCreate />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />

        <Route
          exact
          path={`/base/list`}
          element={
            <ProtectedRoute
              element={<BaseList />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/base/edit/:baseInventoryId`}
          element={<BaseCreate />}
          element={
            <ProtectedRoute
              element={<BaseCreate />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />
        {/* <Route exact path={`/base/edit/:baseInventoryId`} element={<BaseEdit />} /> */}
        {/* Inventory */}
        <Route
          exact
          path={`/list`}
          element={
            <ProtectedRoute
              element={<List />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/create`}
          element={
            <ProtectedRoute
              element={<Create />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/edit/:inventoryId`}
          element={
            <ProtectedRoute
              element={<Create />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
              ])}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default Inventory;
